import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Satellite } from 'lucide-react';
import { useGpsSharing } from '../context/GpsSharingContext';

// Widget flottant global : visible sur toutes les pages quand le partage GPS est actif.
// Un clic ramene au Mode Chauffeur.
const GpsSharingWidget = () => {
    const gps = useGpsSharing();
    const location = useLocation();
    const navigate = useNavigate();

    if (!gps?.sharing || location.pathname === '/chauffeur') return null;

    return (
        <button
            onClick={() => navigate('/chauffeur')}
            data-testid="gps-sharing-widget"
            title="Revenir au Mode Chauffeur"
            className="fixed bottom-20 right-4 z-[1100] flex items-center gap-2 px-4 py-2.5 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white shadow-lg shadow-emerald-900/50 transition-colors"
        >
            <Satellite className="w-4 h-4 flex-shrink-0" />
            <span className="w-2 h-2 rounded-full bg-white animate-pulse flex-shrink-0"></span>
            <span className="text-sm font-semibold whitespace-nowrap">
                Partage actif{gps.vehicleName ? ` — ${gps.vehicleName}` : ''}
            </span>
        </button>
    );
};

export default GpsSharingWidget;
